import { render } from "./AdministracionFacturaComponent.vue?vue&type=template&id=ccdd72c8&scoped=true"
import script from "./AdministracionFacturaComponent.vue?vue&type=script&lang=js"
export * from "./AdministracionFacturaComponent.vue?vue&type=script&lang=js"

import "./AdministracionFacturaComponent.vue?vue&type=style&index=0&id=ccdd72c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ccdd72c8"]])

export default __exports__